export const SET_CERTS = "SET_CERTS";
export const SET_CERTS_LIST = "SET_CERTS_LIST";
export const ADD_CERT = "ADD_CERT";
export const DELETE_CERT = "DELETE_CERT";
